"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.merge = void 0;
const lodash_1 = require("lodash");
/** If more than one DB is used, then we need to combine the configs and take the intersection of features. */
const merge = (...queryEngineConfigs) => {
    return queryEngineConfigs.reduce((acc, current) => {
        const mapIntersection = (key) => {
            let accObj = acc[key];
            let currentObj = current[key];
            if (typeof accObj === 'object' && typeof currentObj === 'object') {
                const keepKeys = (0, lodash_1.intersection)(Object.keys(accObj), Object.keys(currentObj));
                return (0, lodash_1.pick)(current[key], keepKeys);
            }
            throw 'Cannot intersect non-object type in mapIntersection function.';
        };
        return {
            origin: 'query-engine',
            supportedAggregates: mapIntersection('supportedAggregates'),
            supportedFeatures: (0, lodash_1.intersection)(acc.supportedFeatures, current.supportedFeatures),
            supportedOperators: mapIntersection('supportedOperators'),
            supportedTimeTruncFunctions: mapIntersection('supportedTimeTruncFunctions'),
            supportedTransformationFunctions: mapIntersection('supportedTransformationFunctions'),
        };
    }, queryEngineConfigs[0]);
};
exports.merge = merge;
